const containers = {
    en: {
        "containers.title": "Containers",

        "containers.containerHash": "Container#",
        "containers.purchaseDate": "Purchase Date",
        "containers.vehicleName": "Vehicle Name",
        "containers.buyer": "Buyer",
        "containers.booking": "Booking",
        "containers.deliveryLocation": "Delivery Location",
        "containers.containerOpenDate": "Container Open Date",
        "containers.lines": "Lines",
        "containers.personalNumber": "Personal Number",
        "containers.lotStock": "Lot/Stock",
        "containers.loadingPort": "Loading Port",
        "containers.containerLoadedDate": "Container Loaded Date",
        "containers.containerReceiveDate": "Container Recieve Date",

        "containers.setAsOpen": "Set As Open",
        "containers.estimatedOpeningDate": "Estimated Opening Date",
        "containers.openDate": "Open Date",
        "containers.oldToNew": "Old To New",
        "containers.newToOld": "New To Old",
        "containers.filterPort": "Port",
        "containers.selectLine": "Select Line",

        "containers.addTitle": "Add New Container",
        "containers.editTitle": "Modify Container Data",
        "containers.containerNumber": "Container Number",
        "containers.line": "Line",
        "containers.boat": "Boat",
        "containers.selectBoat": "Select Boat",
        "containers.manufacturer": "Manufacturer",
        "containers.model": "Model",
        "containers.manufacturerYear": "Manufacturer Year",
        "containers.lotNumber": "Lot Number",

        "containers.enterVin": "Enter vin code",
        "containers.typeToFilter": "Type to filter",
        "containers.enterContainerNumber": "Enter container number",
        "containers.carsNotFound": "Cars Not Found",

        "containers.setOpenTitle": "Set Container As Open",
        "containers.setOpenConfirm1": "Are you sure you want to set container",
        "containers.setOpenConfirm2": "as open?",
        "containers.setOpenNote": "This action will update the container's status and open date.",
    },
    ru: {
        "containers.title": "Контейнеры",

        "containers.containerHash": "Контейнер#",
        "containers.purchaseDate": "Дата покупки",
        "containers.vehicleName": "Название автомобиля",
        "containers.buyer": "Покупатель",
        "containers.booking": "Бронирование",
        "containers.deliveryLocation": "Место доставки",
        "containers.containerOpenDate": "Дата открытия контейнера",
        "containers.lines": "Линия",
        "containers.personalNumber": "Личный номер",
        "containers.lotStock": "Лот/Сток",
        "containers.loadingPort": "Порт погрузки",
        "containers.containerLoadedDate": "Дата погрузки контейнера",
        "containers.containerReceiveDate": "Дата получения контейнера",

        "containers.setAsOpen": "Отметить как открытый",
        "containers.estimatedOpeningDate": "Ожидаемая дата открытия",
        "containers.openDate": "Дата открытия",
        "containers.oldToNew": "От старых к новым",
        "containers.newToOld": "От новых к старым",
        "containers.filterPort": "Порт",
        "containers.selectLine": "Выберите линию",

        "containers.addTitle": "Добавить контейнер",
        "containers.editTitle": "Редактировать данные контейнера",
        "containers.containerNumber": "Номер контейнера",
        "containers.line": "Линия",
        "containers.boat": "Судно",
        "containers.selectBoat": "Выберите судно",
        "containers.manufacturer": "Производитель",
        "containers.model": "Модель",
        "containers.manufacturerYear": "Год выпуска",
        "containers.lotNumber": "Номер лота",

        "containers.enterVin": "Введите vin код",
        "containers.typeToFilter": "Введите для фильтра",
        "containers.enterContainerNumber": "Введите номер контейнера",
        "containers.carsNotFound": "Автомобили не найдены",

        "containers.setOpenTitle": "Отметить контейнер как открытый",
        "containers.setOpenConfirm1": "Вы уверены, что хотите отметить контейнер",
        "containers.setOpenConfirm2": "как открытый?",
        "containers.setOpenNote": "Это действие обновит статус контейнера и дату открытия.",
    },
    geo: {
        "containers.title": "კონტეინერები",

        "containers.containerHash": "კონტეინერი#",
        "containers.purchaseDate": "შესყიდვის თარიღი",
        "containers.vehicleName": "ავტომობილის დასახელება",
        "containers.buyer": "მყიდველი",
        "containers.booking": "ჯავშანი",
        "containers.deliveryLocation": "მიწოდების ადგილი",
        "containers.containerOpenDate": "კონტეინერის გახსნის თარიღი",
        "containers.lines": "ხაზი",
        "containers.personalNumber": "პირადი ნომერი",
        "containers.lotStock": "ლოტი/სტოკი",
        "containers.loadingPort": "დატვირთვის პორტი",
        "containers.containerLoadedDate": "კონტეინერის დატვირთვის თარიღი",
        "containers.containerReceiveDate": "კონტეინერის მიღების თარიღი",

        "containers.setAsOpen": "გახსნილად მონიშვნა",
        "containers.estimatedOpeningDate": "სავარაუდო გახსნის თარიღი",
        "containers.openDate": "გახსნის თარიღი",
        "containers.oldToNew": "ძველიდან ახლისკენ",
        "containers.newToOld": "ახლიდან ძველისკენ",
        "containers.filterPort": "პორტი",
        "containers.selectLine": "აირჩიეთ ხაზი",

        "containers.addTitle": "ახალი კონტეინერის დამატება",
        "containers.editTitle": "კონტეინერის მონაცემების რედაქტირება",
        "containers.containerNumber": "კონტეინერის ნომერი",
        "containers.line": "ხაზი",
        "containers.boat": "გემი",
        "containers.selectBoat": "აირჩიეთ გემი",
        "containers.manufacturer": "მწარმოებელი",
        "containers.model": "მოდელი",
        "containers.manufacturerYear": "წარმოების წელი",
        "containers.lotNumber": "ლოტის ნომერი",

        "containers.enterVin": "შეიყვანეთ vin კოდი",
        "containers.typeToFilter": "აკრიფეთ ფილტრისთვის",
        "containers.enterContainerNumber": "შეიყვანეთ კონტეინერის ნომერი",
        "containers.carsNotFound": "ავტომობილები ვერ მოიძებნა",

        "containers.setOpenTitle": "კონტეინერის გახსნილად მონიშვნა",
        "containers.setOpenConfirm1": "დარწმუნებული ხართ, რომ გსურთ კონტეინერის",
        "containers.setOpenConfirm2": "გახსნილად მონიშვნა?",
        "containers.setOpenNote": "ეს მოქმედება განაახლებს კონტეინერის სტატუსსა და გახსნის თარიღს.",
    },
};

export default containers;
